import LIVE_USAGES from '@Domain/Enums/Ai/LiveUsages';
import { REALTIME_DELIVERY_MODE } from '@UI/Pages/Administration/AiEngines/realtimeDeliveryRules';

/** The minimal shape this constraint reads. */
type LiveUsageShape = {
	readonly usages: string[];
};

/** A model carrying a live usage must be delivered in real time. */
function isLiveUsageRealtime<T extends LiveUsageShape>(value: string | null, formData: T): boolean {
	const hasLiveUsage = formData.usages.some((usage) => LIVE_USAGES.includes(usage));

	return !hasLiveUsage || value === REALTIME_DELIVERY_MODE;
}

export default isLiveUsageRealtime;
